// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"230":"01bb42dd","453":"d9b724db","833":"64d3e363"}[chunkId] + ".chunk.js";
};